import { SortBy } from './tabs/Transactions/Transactions.meta';

export enum PerformancePeriodDTO {
  YTD,
  OneYear,
  ThreeYears,
  FiveYears,
  PreviousOneYear,
  PreviousTwoYear,
  PreviousThreeYear,
  AllTime,
  QTD,
  MTD,
  TenYears,
  L30,
}

export enum TransactionsPeriodDTO {
  Last30Days,
  Last90Days,
  LastYear,
  OneYear,
  MonthToDate,
  YearToDate,
  SinceInception,
}

export interface PortfoliosInceptionDTO {
  accounts: {
    id: string;
    inceptionDate: string | null;
  }[];

  groups: {
    id: number;
    inceptionDate: string | null;
  }[];
}

export interface PerformancePeriodOptionDTO {
  label: string;
  value: PerformancePeriodDTO;
  range: {
    startDate: string;
    endDate: string;
  };
}

export interface TransactionsSettingsDTO {
  showCostBasis: boolean;
}

interface PortfolioGroup {
  id: string | null;
  name: string;
  nameId: string;
  selectable: boolean;
}

interface GroupDetails {
  portfolioGroup: PortfolioGroup;
  accounts: any[];
}

export type ManagedAccountGroups = Record<string, GroupDetails>;

export enum TabSlug {
  Activity = 'activity',
  Allocation = 'allocation',
  Income = 'income',
  Performance = 'performance',
  Summary = 'summary',
  RiskProfile = 'riskProfile',
  RmdDashboard = 'rmdDashboard',
}

export interface TransactionFilters {
  period: {
    label: string;
    value?: PerformancePeriodDTO;
    dates: string[];
  };
  sortBy: SortBy;
  sortDesc: boolean;
  query: string;
}
